import { createPortal } from "react-dom";
import { LoadingSpinner } from "./LoadingSpinner";

export const LoadingOverlay = () => {
    return createPortal(
        <div
            className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{
                backgroundColor: "rgba(0,0,0,0.35)",
                zIndex: 999999,
                pointerEvents: "auto"
            }}
        >
            <LoadingSpinner color="gray" />
        </div>,
        document.body
    );
};